<!--
 * @Author: 请在根目录下.vscode改成你的名字
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:58
 * @LastEditTime: 2019-09-29 13:46:33
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 运单时间轴
 -->
<template>
  <div>
    <ul class="timeline">
      <template v-for="(item, index) of data">
        <time-line-item v-if="index === data.length - 1 && item.startPlace == startPlace" :key="index" :is-end="true" :timestamp="item.startSportDate" status="开始运输">
          <template v-slot:icon>
            <img src="@/assets/img/monitor/car.png">
          </template>
          <template>
            <ul class="transport-info">
              <li>{{ item.transportTypeLabel }}运输</li>
              <li v-if="index === data.length - 1 ">货物从起运地{{ (item.startPlace + item.startPlaceDtl)|formatPlace }}开始运输</li>
              <li><p>运单编号:{{ item.tsOrderNum }}</p></li>
              <li>货物重量:{{ item.weight }} 吨</li>
            </ul>
          </template>
        </time-line-item>
        <time-line-item v-else-if="index === 0 && data.length-1 > 0 && item.stopSportDate && item.stopPlace == endPlace" :key="index" :timestamp="item.startSportDate" status="运输结束" :is-active="true">
          <template v-slot:icon>
            <img src="@/assets/img/monitor/activeCar.png">
          </template>
          <template>
            <ul class="transport-info">
              <li>{{ item.transportTypeLabel }}运输</li>
              <li>货物已到达目的地{{ (item.stopPlace + item.stopPlaceDtl)|formatPlace }}</li>
              <li><p>运单编号:{{ item.tsOrderNum }}</p></li>
              <li>货物重量:{{ item.weight }} 吨</li>
            </ul>
          </template>
        </time-line-item>

        <time-line-item v-else-if="!(index === data.length - 1 && item.startPlace == startPlace) && !(index === 0 && data.length-1 > 0 && item.stopSportDate && item.stopPlace == endPlace)" :key="index" :timestamp="item.startSportDate" status="运输中">
          <template>
            <ul class="transport-info">
              <li>{{ item.transportTypeLabel }}运输</li>
              <li v-if="item.stopSportDate">货物抵达{{ (item.stopPlace + item.stopPlaceDtl)|formatPlace }}</li>
              <li v-else>从{{ item.startPlace + item.startPlaceDtl }} 正在发往{{ (item.stopPlace + item.stopPlaceDtl)|formatPlace }}</li>
              <li><p>运单编号:{{ item.tsOrderNum }}</p></li>
              <li>货物重量:{{ item.weight }} 吨</li>
            </ul>
          </template>
        </time-line-item>
      </template>
    </ul>
  </div>
</template>
<script>
import TimeLineItem from './time-line-item'
export default {
  name: 'TimeLine',
  components: {
    'time-line-item': TimeLineItem
  },
  filters: {
    formatDate(val) {
      return val.replace(/-/g, '/')
    },
    formatPlace(val) {
      return val.replace(/\//g, '').replace(/null/g, '').replace(/\d*/g, '')
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    reverse: {
      type: Boolean,
      default: () => true
    },
    startPlace: {
      type: String,
      default: () => ''
    },
    endPlace: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {

    }
  },
  created() {
    if (this.data && this.data.length > 0 && this.reverse) {
      this.data.reverse()
    }
  }
}
</script>
<style lang="scss" scoped>
.timeline {
   position: relative;
   top: 12px;
  .transport-info {
    li {
      font-size: 14px;
      line-height: 18px;
      word-break: break-all;
    }
  }
}
</style>

